<div class="task-manager" id="taskManager">
  <div class="task-manager-container" *ngIf="!state.inDetailsView">
    <div class="task-manager outline">
      <div class="task-manager-table fill">
        <div class="task-manager-table-cell task-manager-buttons-area">
          <div class="task-manager-table-row heading-row">
            <div class="task-manager-processes-area cell-left">
              {{ 'taskManager_tasks' | xsI18n }}
            </div>
            <div class="task-manager-refresh-area">
              <div
                class="manual-refresh-button"
                (click)="state.manualRefreshProcesses()"
                [ngClass]="{ 'refresh-interval-manual': isRefreshIntervalManual() }"
              >
                <span
                  [ngClass]="{ 'refresh-disabled': state.isManualRefreshDisabled() }"
                  class="hd-icon icon-sm hd-icon_retry"
                ></span>
              </div>
              <span>{{ 'taskManager_refresh_interval' | xsI18n }}</span>
              <div class="refresh-dropdown-container">
                <soti-select
                  class="refresh-dropdown group-dropdown-select"
                  [(ngModel)]="state.refreshSpeed"
                  [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="state.setRefreshSpeed($event.value)"
                >
                  <soti-option class="dropdown-option" [value]="item.value.id" *ngFor="let item of state.refreshSpeeds | keyvalue">
                    {{ item.value.caption }}
                  </soti-option>
                </soti-select>
              </div>
            </div>
          </div>
        </div>
        <div
          class="task-manager-table-row heading-row heading-overflow-hidden"
          id="taskManagerHeadings"
          *ngIf="!state.isWindows()"
        >
          <div class="task-manager-table-cell heading-cell cell-left" (click)="sortBy('name')">
            {{ 'xs_name_label' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'name'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
          <div class="task-manager-table-cell heading-cell cell-right fill" (click)="sortBy('uid')">
            {{ 'taskManager_uid' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'uid'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
          <div class="task-manager-table-cell heading-cell cell-right fill" (click)="sortBy('pid')">
            {{ 'taskManager_pid' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'pid'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
          <div class="task-manager-table-cell heading-cell cell-right fill" (click)="sortBy('memory')">
            {{ 'taskManager_memory' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'memory'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
        </div>
        <div
          class="task-manager-table-row heading-row heading-overflow-hidden"
          id="taskManagerHeadings"
          *ngIf="state.isWindows()"
        >
          <div class="task-manager-table-cell heading-cell cell-left" (click)="sortBy('name')">
            {{ 'xs_name_label' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'name'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
          <div class="task-manager-table-cell heading-cell cell-ce-type cell-right fill" (click)="sortBy('type')">
            {{ 'taskManager_type' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'type'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
          <div class="task-manager-table-cell heading-cell cell-right fill" (click)="sortBy('pid')">
            {{ 'taskManager_pid' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'pid'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
          <div class="task-manager-table-cell heading-cell cell-right fill" (click)="sortBy('cpuUsage')">
            {{ 'taskManager_cpu_usage' | xsI18n }}
            <span
              *ngIf="taskListSortInfo.column === 'cpuUsage'"
              class="hd-icon icon-sm"
              [ngClass]="taskListSortInfo.reverse ? 'hd-icon-sortdown' : 'hd-icon-sortup'"
            ></span>
          </div>
        </div>
      </div>
      <div class="task-manager-table task-area" id="taskManagerScrollArea">
        <div *ngIf="state.isWindows()">
          <div
            class="task-manager-table-row row-highlight bottom-border"
            *ngFor="let task of getTaskList(); let i = index"
            (click)="state.toggleSelectedTask(task, i, 'taskManagerItem_' + i)"
            id="taskManagerItem_{{ i }}"
          >
            <div
              class="task-manager-table-cell cell-left align-left fit-content"
              [ngClass]="{ on: state.isTaskActionAllowed(task.pid) }"
            >
              <div
                class="fit-content-child"
                (click)="getDetails(task)"
                href="#"
                [soti-tooltip]="task.name"
                placement="top"
                [delay]="500"
              >
                {{ task.name }}
              </div>
            </div>
            <div
              class="task-manager-table-cell cell-right cell-ce-type fill"
              [ngClass]="{ on: state.isTaskActionAllowed(task.pid) }"
              hd-ellipsis-text
            >
              {{ task.type }}
            </div>
            <div class="task-manager-table-cell cell-right fill" [ngClass]="{ on: state.isTaskActionAllowed(task.pid) }">
              {{ task.pid }}
            </div>
            <div class="task-manager-table-cell cell-right fill" [ngClass]="{ on: state.isTaskActionAllowed(task.pid) }">
              {{ task.cpuUsageStr }}
            </div>
          </div>
        </div>
        <div *ngIf="!state.isWindows()">
          <div class="task-manager-table-row bottom-border" *ngFor="let task of getTaskList(); let i = index">
            <div class="task-manager-table-cell cell-left align-left fit-content">
              <div
                class="fit-content-child task-manager-task-name"
                (click)="getDetails(task)"
                [matTooltip]="task.name"
                matTooltipPosition="above"
                matTooltipClass="assist-mat-tooltip"
                [matTooltipShowDelay]="500"
                [matTooltipDisabled]="task.name.length < 20"
              >
                {{ task.name }}
              </div>
            </div>
            <div class="task-manager-table-cell cell-right fill">{{ task.uid }}</div>
            <div class="task-manager-table-cell cell-right fill">{{ task.pid }}</div>
            <div class="task-manager-table-cell cell-right fill">{{ task.memoryStr }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="actionBar"
      class="task-manager-table"
      *ngIf="state.isTaskSelected() && state.isWindows() && state.isKillPermission"
    >
      <div class="task-manager-table-cell action-bar footer-cell">
        <div class="task-manager-table-row">
          <div class="action-bar-section footer-cell">
            <!-- TODO: fix this when we add support for multi select -->
            <span class="badge badge-action-bar badge-success">1</span>
            <span class="action-bar-badge-caption">{{ 'taskManager_process_selected' | xsI18n }}</span>
          </div>
          <div class="action-bar-section footer-cell middle text-center">
            <div class="action-bar-button">
              <div class="action-bar-button-icon">
                <div class="content">
                  <span
                    class="killPopupTrigger hd-icon icon-xlg hd-icon-stop kill-process-button no-gutter"
                    [sotiPopupTriggerFor]="killPopup"
                    #killPopupTrigger="sotiPopupTrigger"
                  >
                  </span>
                  <soti-popup #killPopup="sotiPopup">
                    <h3 class="xsight-headline5 popover-title">{{ 'popover_Confirm_Title' | xsI18n }}</h3>
                    <div class="popover-content">
                      <div>
                        <div class="popover-body">
                          <div class="popover-body-text">{{ 'taskManager_kill_popover_content' | xsI18n }}</div>
                        </div>
                        <div class="popover-footer">
                          <button
                            class="xs-btn btn-outline btn-space"
                            type="button"
                            (click)="closePopup($event)"
                          >
                            <span>{{ 'xs_cancel_label_short' | xsI18n }}</span>
                          </button>
                          <button class="xs-btn btn-primary" (click)="killProcess($event)">
                            <span>{{ 'taskManager_kill_confirm_text' | xsI18n }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </soti-popup>
                </div>
              </div>
              <div class="action-bar-button-caption">
                <div class="content">{{ 'taskManager_kill' | xsI18n }}</div>
              </div>
            </div>
          </div>
          <div class="action-bar-section"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="task-details-container" *ngIf="state.inDetailsView">
    <app-task-details [deviceKind]="deviceKind"></app-task-details>
  </div>
</div>
